import api from 'ApiConfig';

const practicalTestService = {
  createPracticalTest: async (data) => {
    return api.post('/teacher/create-practical-test', data);
  },
  getAllPracticalTests: async (batchId) => {
    return api.post('/teacher/get-practical-tests', { batchId });
  },
  updatePracticalTest: async (data) => {
    return api.post('/teacher/update-practical-test', data);
  },
  deletePracticalTest: async (id) => {
    return api.post('/teacher/delete-practical-test', { id });
  },
  getSubmissions: async (testId) => {
    return api.post('/teacher/get-practical-test-submissions', { testId });
  },
  gradeSubmissions: async (testId, outOf, marksData) => {
    return api.post('/teacher/grade-practical-test-submissions', { testId, outOf, marksData });
  },
  handleDriveLinkPermission: async (submissionId, action) => {
    return api.post('/teacher/handle-drive-link-permission', { submissionId, action });
  },
};

export default practicalTestService;
